// extracted by mini-css-extract-plugin
module.exports = {"container":"Cases_container__3Ken1","row":"Cases_row__OpJKU","col":"Cases_col__2sepq"};